<core-block-pullout
    [style]="`
          --pullout-image-min-height: ${block.data.imageMinHeight || '100%'};
          --pullout-image-max-height: ${block.data.imageHeight};
          --pullout-image-flex-basis: ${block.data.imageWidth};
          --pullout-body-flex-basis: calc(100% - var(--pullout-image-flex-basis));
          ${block.data.contentPadding ? `--pullout-body-padding: ${block.data.contentPadding};` : ''}
          --pullout-theme-opacity: ${block.data.appearance === 'transparent-outline' ? 0 : (block.data.themeOpacity ?? 1)};`"
    [style.--pullout-eyebrow-color]="block.data.useEyebrowColorOverride ? block.data.eyebrowColorOverride : null"
    [style.--pullout-title-color]="hasHeadingColorOverride ? block.data.headingColorOverride : null"
    [style.--pullout-title-font-size]="hasCustomHeadingStyles ? block.data.headingFontSize : null"
    [style.--pullout-title-font-weight]="hasCustomHeadingStyles ? block.data.headingFontWeight : null"
    [style.--pullout-body-font-size]="hasCustomDescriptionStyles ? block.data.descriptionFontSize : null"
    [style.--btn-border-radius-medium]="hasCustomButtonBorderRadius ? block.data.buttonBorderRadius : null"
    [style.--btn-font-size-medium]="pulloutConfig()?.cta?.fontSize ?? null"
    [style.--btn-padding-medium]="pulloutConfig()?.cta?.padding ?? null"
    [style.--pullout-description-color]="
        block.data.useDescriptionColorOverride ? block.data.descriptionColorOverride : null
    "
    [attr.data-theme]="block.data.theme"
    [attr.data-appearance]="block.data.appearance"
    [attr.data-image-align]="imageAlignment"
    [attr.data-image-padding]="block.data.includeImagePadding ? 'true' : null"
    [attr.data-text-color-override]="block.data.useTextColorOverride ? block.data.textColorOverride : null"
    [attr.data-flat-corners]="block.data.removeBorderRadius ? 'true' : null"
    [attr.data-cta-icon]="hasCtaIcon ? 'true' : null"
    [eyebrow]="block.data.eyebrow"
    [heading]="block.data.heading"
    [description]="block.data.description"
    [linkText]="block.data.includeCTA && block.data.ctaText"
    [linkHref]="block.data.includeCTA && block.data.ctaUrl"
    [externalLink]="block.data.isCtaExternalLink"
    [linkAsEntireElement]="showLinkAsEntireElement"
    [image]="block.data.includeImage && block.data.image"
    [imageAltText]="block.data.altText"
    [imagePosition]="block.data.imagePosition"
    [buttonPosition]="block.data.buttonPosition || 'bottom'"
    [buttonVariant]="block.data.buttonVariant"
    [buttonIcon]="hasCtaIcon ? block.data.buttonIcon : ''"
    [buttonIconPlacement]="block.data.buttonIconPosition"
    coreLinkify></core-block-pullout>
